var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVisaCardSmaller = function SvgVisaCardSmaller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20.4,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.64 0H1.36A1.36 1.36 0 000 1.36v17.68c0 .751.609 1.36 1.36 1.36h31.28A1.36 1.36 0 0034 19.04V1.36A1.36 1.36 0 0032.64 0z",
    fill: "#26337a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.106 13.447l1.046-6.485h1.671l-1.045 6.485zM21.84 7.12a4.13 4.13 0 00-1.498-.272c-1.653 0-2.815.88-2.825 2.14-.01.932.83 1.452 1.464 1.762.65.318.87.52.867.805-.005.434-.52.633-1 .633-.67 0-1.025-.098-1.574-.34l-.215-.103-.234 1.451c.39.181 1.112.338 1.861.346 1.757 0 2.897-.87 2.91-2.215.007-.74-.439-1.3-1.403-1.762-.584-.3-.942-.5-.938-.804 0-.27.302-.559.957-.559.547-.008.942.118 1.25.25l.15.074zM24.065 11.146c.138-.373.665-1.813.665-1.813-.01.017.138-.375.222-.618l.113.559.387 1.872zm2.06-4.18h-1.29c-.401 0-.701.115-.876.538l-2.482 5.943h1.755s.287-.799.352-.975l2.14.004c.05.226.203.971.203.971h1.551zM12.705 6.966l-1.636 4.422-.175-.9c-.305-1.035-1.254-2.157-2.315-2.72l1.496 5.672h1.769l2.632-6.474z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55 6.962H6.857l-.022.134c2.097.537 3.484 1.834 4.06 3.393l-.586-2.98c-.1-.411-.394-.533-.757-.547z",
    clipRule: "evenodd",
    fill: "#ed982d",
    fillRule: "evenodd"
  })));
};
export default SvgVisaCardSmaller;